import React, { startTransition } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import css from "./LogOutComponent.module.css";
import { authActions } from "../../store/slices/auth-slices";
import { useTranslation } from "react-i18next";

const LogOutComponent = ({ children, className, ...props }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(authActions.logout()).unwrap().then(() => {
      startTransition(() => {
        navigate("/login");
      });
    });
  };

  return (
    <section className={css.wrap} onClick={handleLogout}>
      <span className={css.logoutIcon}>
        <svg
          data-v-0b661339=""
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1024 1024"
        >
          <path
            fill="currentColor"
            d="M352 159.872V230.4a352 352 0 1 0 320 0v-70.528A416.128 416.128 0 0 1 512 960a416 416 0 0 1-160-800.128z"
          ></path>
          <path
            fill="currentColor"
            d="M512 64q32 0 32 32v320q0 32-32 32t-32-32V96q0-32 32-32z"
          ></path>
        </svg>
      </span>

      <span className={css.logoutText}>{t("aside-logout")}</span>
    </section>
  );
};

export { LogOutComponent };
